import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {
  Balances,
  EditedRecord,
  PendingTimeOffRequest,
  RequestTypes
} from '../../../models/TimeOffModels';
import { parseTimeString } from '../../../utils/datepicker-value-parser';
import { TimeOffRequestService } from '../../../services/time-off-request.service';
import { GetHoursBetweenTwoDates, GetHoursBetweenTwoTimes } from '../../../utils/dateUtils';
import { Observable, of, Subject } from 'rxjs';
import { filter, first, map, mergeMap, takeUntil } from 'rxjs/operators';
import { EmployeePTO, PTOConfig } from '../../../models/paid-time-off';
import { CompaniesService } from '../../../services/companies.service';
import { Select, Store } from '@ngxs/store';
import {
  TimeOffLoadBalances,
  TimeOffRequestsState
} from '../../../state/TimeOffRequestsState/TimeOffRequests.state';
import { ClientSelectionState } from '../../../state/ClientSelectionState/ClientSelection.state';

@Component({
  selector: 'lib-hours-display',
  templateUrl: './hours-display.component.html',
  styleUrls: ['./hours-display.component.css'],
  standalone: false
})
export class HoursDisplayComponent implements OnInit, OnDestroy {
  @Input()
  public employeeHomepageHeader: boolean = false;
  @Select(TimeOffRequestsState.getPTOConfigs)
  public ptoConfigs: Observable<PTOConfig[]>;
  @Select(TimeOffRequestsState.getEmployeePtos)
  public employeePtos: Observable<EmployeePTO[]>;

  @Select(TimeOffRequestsState.getOpenRequests)
  public openRequests: Observable<PendingTimeOffRequest[]>;
  @Select(TimeOffRequestsState.getEditedRequests)
  public editedRequests: Observable<EditedRecord[]>;

  @Select(TimeOffRequestsState.getCollectiveAvailableBalance)
  collectiveAvailableBalance: Observable<number>;

  @Select(TimeOffRequestsState.getCollectiveRequested)
  collectiveRequested: Observable<number>;

  @Select(TimeOffRequestsState.getCollectivePendingChange)
  collectivePendingChange: Observable<number>;

  @Select(TimeOffRequestsState.getCollectiveApproved)
  collectiveApproved: Observable<number>;

  @Input()
  public editedRequest: EditedRecord | null = null;
  @Input()
  public existingModel: PendingTimeOffRequest | null = null;

  @Input()
  public personId: number = null;

  @Select(TimeOffRequestsState.getCurrentRequestHours)
  public currentRequestHours: Observable<number>;

  @Input()
  public planId: Observable<number> | null = null;
  @Input()
  public initialRequestHours: number | null;
  @Input()
  public currentRequestHoursObs: Observable<number> | null = null;

  @Input()
  public currentRequestIsApproved: boolean = false;

  protected readonly RequestTypes = RequestTypes;

  @Select(TimeOffRequestsState.getBalances)
  public balances: Observable<Balances[]>;

  public planBalance: Balances = null;
  private lastBalanceNegativeResult = false;

  private destroy$ = new Subject<void>();
  @Select(TimeOffRequestsState.getAccruedBalance)
  public accruedBalance: Observable<number>;
  @Select(TimeOffRequestsState.getUsedBalance)
  public usedBalance: Observable<number>;
  @Select(TimeOffRequestsState.getCurrentBalance)
  public currentBalance: Observable<number>;
  @Select(TimeOffRequestsState.getApprovedBalance)
  public approvedBalance: Observable<number>;
  public pendingChange: Observable<number>;

  public requestedHours: Observable<number>;

  public availableBalance: Observable<number>;

  public remainingBalance: Observable<number>;
  constructor(
    private employeeTimeOffService: TimeOffRequestService,
    private companiesService: CompaniesService,
    private store: Store
  ) {}

  ngOnInit() {
    this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
      this.store
        .dispatch(new TimeOffLoadBalances(code, this.existingModel?.PersonId ?? this.personId))
        .subscribe(_ => {
          this.requestedHours = this.store.select(
            TimeOffRequestsState.getRequestedBalance(this.personId)
          );
          this.pendingChange = this.store.select(
            TimeOffRequestsState.getPendingBalance(this.personId)
          );
          this.availableBalance = this.store.select(
            TimeOffRequestsState.getAvailableBalance(this.personId)
          );
          this.remainingBalance = this.store.select(
            TimeOffRequestsState.getRemainingBalance(this.personId)
          );
        });
    });
  }

  public getPtoName(id: number) {
    return this.ptoConfigs.pipe(
      map(x => x.filter(y => y.Id == id)),
      map(x => {
        if (x.length > 0) {
          return x[0].Name;
        }
        return '';
      })
    );
  }
  public getPtoActive(id: number) {
    return this.ptoConfigs.pipe(
      map(x => x.filter(y => y.Id == id)),
      mergeMap(x => {
        if (x.length > 0) {
          if (x[0].IsActive) {
            return this.employeePtos.pipe(
              map(ptos => {
                const pto = ptos.find(y => y.Id == id);
                return pto?.IsActive ?? false;
              })
            );
          }
        }
        return of(false);
      })
    );
  }
  ngOnDestroy() {
    this.destroy$.next();
  }

  private updateBalances() {
    if (this.planBalance != null) {
      /* if(this.currentRequestIsApproved && this.initialRequestHours != null) {
      this.approvedBalance = this.planBalance.Approved - this.initialRequestHours;
    } else {
      this.approvedBalance = this.planBalance.Approved;
    } */
      if (this.openRequests != null) {
        // const requests = this.openRequests.filter(x => x.Request.TimeOffType == this.planBalance.PlanId && x.PersonId == this.personId);
        //  const edited = this.editedRequests.filter(x => x.EditedRecord.PlanId == this.planBalance.PlanId && x.EditedRecord.PersonId == this.personId);
        // this.pendingChange = this.calculatePending(requests, edited);
        // this.requestedHours = this.calculateRequested(requests);
      }
    }
  }
}
